import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.8);\n  z-index: 998;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.3s ease-in-out;\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import { PREPROD_PREVIEW_ACTIONS } from "./context/types";
import { usePreproductPreviewContext } from "./context/Context";
import { useModalOverlay } from "./hooks/useModalOverlay";
var overlayVisibleStyles = "\n    opacity: 1;\n    pointer-events: auto;\n";
export var OverlayComponent = styled.div.attrs({
    role: "presentation"
}).withConfig({
    componentId: "sc-30f4c96d-0"
})(_templateObject(), function(param) {
    var isVisible = param.isVisible;
    return isVisible && overlayVisibleStyles;
});
export var Overlay = function() {
    var ref = usePreproductPreviewContext(), dispatch = ref.dispatch, boardContainerState = ref.boardContainerState;
    useModalOverlay(boardContainerState.boardContainerDisplayMode === "modal");
    var handleClick = function(e) {
        e.stopPropagation();
        dispatch({
            type: PREPROD_PREVIEW_ACTIONS.SET_BOARD_CONTAINER_DISPLAY_MODE,
            payload: "inline"
        });
    };
    return /*#__PURE__*/ _jsx(OverlayComponent, {
        isVisible: boardContainerState.boardContainerDisplayMode === "modal",
        onClick: handleClick
    });
};
